"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withOptionals = exports.isNotEmpty = exports.zipObjects = void 0;
function zipObjects(objLeft, objRight) {
    const allKeys = [
        ...new Set(Object.keys(objLeft || {}).concat(Object.keys(objRight || {}))),
    ];
    return allKeys.reduce((acc, key) => {
        const left = objLeft === null || objLeft === void 0 ? void 0 : objLeft[key];
        const right = objRight === null || objRight === void 0 ? void 0 : objRight[key];
        return {
            ...acc,
            [key]: { left, right },
        };
    }, {});
}
exports.zipObjects = zipObjects;
function isNotEmpty(obj) {
    return Boolean(Object.keys(obj).length);
}
exports.isNotEmpty = isNotEmpty;
function withOptionals(object, optionals) {
    return {
        ...object,
        ...optionals.reduce((acc, [key, value]) => {
            return value ? { ...acc, [key]: value } : acc;
        }, {}),
    };
}
exports.withOptionals = withOptionals;
